// import { useState } from 'react';
import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import { CoinImage } from '@/app/shared/components';

interface InviteFriendCardProps {
	title: string;
	image: string;
	gradient: string;
	// text: string;
	shurikens: number;
}

export const InviteFriendCard: React.FC<InviteFriendCardProps> = ({
	title,
	image,
	gradient,
	// text,
	shurikens,
}: InviteFriendCardProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div
			className={`${gradient} rounded-lg py-4 px-2 flex flex-col gap-1 justify-around flex-1`}
		>
			<div className="flex items-center justify-center min-h-[110px]">
				<img className="h-[110px]" src={image} alt={title} />
			</div>

			<div className="flex flex-col justify-center items-center">
				<p className="text-md font-bold text-center flex items-center justify-center">
					{title}
				</p>
				<div className="flex items-center">
					<CoinImage />
					<p className="text-sm font-bold text-center text-yellow-400 text-shadow-sm">
						+{numify(shurikens)}
					</p>
				</div>
				{/* <p className="text-xs text-center">{text}</p> */}
			</div>
		</div>
	);
};
